<template>
  <b-card border-variant="light">
    <div class="widget-label" v-if="title">
      <div class="label">
        <p>{{ title }}</p>
      </div>
    </div>
    <div class="p-0 widget-content">
        <!-- v-else -->
      <!-- <AttendeesEntries
        :attendees="displayableAttendees"
        :action="action"
        :column="column"
        @handleRemove="$parent.handleAttendeeRemove"
        @handleAdd="$parent.handleAttendeeAdd"
      /> -->
      <p v-if="comments.length == 0 && searchText != ''">
        {{ emptyText }}
      </p>
    </div>

    <b-card-footer
      v-if="comments.length > 5 && searchText.length == 0"
      class="no-border__footer"
      style="background: white"
    >
      <b-button class="text-button">
        Show all {{ comments.length }} Attendees
      </b-button>
      <b-modal
        ref="more-attendees-modal"
        :title="title"
        ok-only
        ok-title="Close"
      >
        <!-- <AttendeesEntries
          :attendees="attendees"
          :action="action"
          @handleRemove="$parent.handleAttendeeRemove"
          @handleAdd="$parent.handleAttendeeAdd"
        /> -->
      </b-modal>
    </b-card-footer>
    <b-card-text v-if="!(comments.length > 0)" style="margin: 20px">
      <p>{{ emptyText }}</p>
    </b-card-text>
  </b-card>
</template>

<script>
// import AttendeesEntries from "../list-entries/AttendeesEntries.vue";
export default {
  name: "MeetingCommentsList",
  components: {  },
  data() {
    return {
      // searchText: "",
    };
  },
  props: {
    title: { type: String },
    comments: { type: Array, required: true},
    emptyText: { type: String, default: "No Comments" },
    action: { type: String, default: "" },
    searchText: { type: String, default: "" },
  },
  methods: {
    toggleAttending(userId) {
      let attendee = this.attendees.find((a) => a.userId === userId);
      if (attendee.attending) {
        this.$parent.handleAttendeeRemove(attendee);
      } else {
        this.$parent.handleAttendeeAdd(attendee);
      }
    },
    showModal(name) {
      this.$refs[name].show();
    },
    borderClassByRole(attendee) {
      if (attendee.role == "Owner") {
        return "owner";
      } else if (attendee.role == "Contractor") {
        return "contractor";
      } else {
        return "";
      }
    },
  },
  computed: {
    
  },
};
</script>

<style lang="scss" scoped>
</style>